"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateStepLabels = exports.buildAcknowledgeText = exports.allRegistersHasPlausibilityReason = void 0;
exports.getMeterFromSessionStorage = getMeterFromSessionStorage;
exports.saveData = saveData;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _MeterReadingPage = require("../../../cic/pages/MeterReadingPage/MeterReadingPage");
var _SessionHandler = _interopRequireDefault(require("../../../utils/SessionHandler"));
var _meterReadingFormHelper = require("./IntermediateReadingForm/meterReadingFormHelper");
var _meterReadingApi = require("../../../cic/api/meterReadingApi");
var _meterReadingFormHelper2 = require("../../../cic/components/MeterRead/Anonym/MeterReadingForm/meterReadingFormHelper");
var buildAcknowledgeText = exports.buildAcknowledgeText = function buildAcknowledgeText(props) {
  var missedMeter = props.missedMeter,
    amount = props.amount,
    metersRegisteredText = props.metersRegisteredText,
    fromToMetersRegisteredText = props.fromToMetersRegisteredText;
  var str = '';
  if (missedMeter === 0) {
    str = "".concat(amount, " ").concat(metersRegisteredText);
  } else if (fromToMetersRegisteredText) {
    str = fromToMetersRegisteredText.replace('%%SUCCESS%%', (amount - missedMeter).toString()).replace('%%TOTAL%%', amount.toString());
  }
  return str;
};
function saveData(values, formikHelpers, setApiError, setCurrentStep) {
  var setFieldValue = formikHelpers.setFieldValue,
    setSubmitting = formikHelpers.setSubmitting;
  var meterData = (0, _meterReadingFormHelper.prepareMeterReadingData)(values);
  (0, _meterReadingApi.saveMeterReadingData)(meterData).then(function () {
    (0, _meterReadingFormHelper2.storeMeterDataForEmailDispatch)((0, _meterReadingFormHelper2.buildMeterDataForEmailDispatch)(values));
    setSubmitting(false);
    setCurrentStep(_MeterReadingPage.MeterReadingWizardStepEnum.EMAIL_FEEDBACK);
  }).catch(/*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(error) {
      var _error$response, status, statusText, tempValues, response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _error$response = error.response, status = _error$response.status, statusText = _error$response.statusText;
              if (!(status === 422)) {
                _context.next = 9;
                break;
              }
              tempValues = (0, _toConsumableArray2.default)(values.registers);
              response = error.response.data;
              response.errors.forEach(function (errorItem) {
                if (errorItem.code !== 'global.validation.missingValue') {
                  var _errorItem$args;
                  var fieldValue = ((_errorItem$args = errorItem.args) === null || _errorItem$args === void 0 ? void 0 : _errorItem$args.field) || '';
                  var index = parseInt(fieldValue.substring(fieldValue.indexOf('[') + 1, fieldValue.indexOf(']')), 10);
                  if (index >= 0) {
                    var _errorItem$args2;
                    tempValues[index].possibleReadingNotes = (_errorItem$args2 = errorItem.args) === null || _errorItem$args2 === void 0 ? void 0 : _errorItem$args2.readingNotes;
                    tempValues[index].errorCode = errorItem.code;
                  }
                }
              });
              _context.next = 7;
              return setFieldValue('registers', tempValues, false);
            case 7:
              _context.next = 10;
              break;
            case 9:
              setApiError(status, statusText);
            case 10:
              setSubmitting(false);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
var generateStepLabels = exports.generateStepLabels = function generateStepLabels(_ref2, canSeeRegister) {
  var meterValueLabel = _ref2.meterValueLabel,
    emailConfirm = _ref2.emailConfirm,
    register = _ref2.register,
    done = _ref2.done;
  var stepLabelsArray = [{
    label: meterValueLabel,
    step: _MeterReadingPage.MeterReadingWizardStepEnum.READING
  }, {
    label: emailConfirm,
    step: _MeterReadingPage.MeterReadingWizardStepEnum.EMAIL_FEEDBACK
  }, {
    label: register,
    step: _MeterReadingPage.MeterReadingWizardStepEnum.REGISTER
  }, {
    label: done,
    step: _MeterReadingPage.MeterReadingWizardStepEnum.FINISHED
  }];
  if (!canSeeRegister) stepLabelsArray.splice(2, 1);
  return stepLabelsArray;
};
function getMeterFromSessionStorage(intermediateReadingData) {
  var meterNumber = _SessionHandler.default.getIntermediateReadingMeterNumber();
  var foundEntry = intermediateReadingData.find(function (meter) {
    if ((meter === null || meter === void 0 ? void 0 : meter.obfuscationActive) && (meter === null || meter === void 0 ? void 0 : meter.serialNumberObfuscated)) {
      var _meter$serialNumberOb;
      return meterNumber === null || meterNumber === void 0 ? void 0 : meterNumber.endsWith(meter === null || meter === void 0 ? void 0 : (_meter$serialNumberOb = meter.serialNumberObfuscated) === null || _meter$serialNumberOb === void 0 ? void 0 : _meter$serialNumberOb.replace(/^[xX]*/, ''));
    }
    return meter.serialNumber === meterNumber;
  });
  return foundEntry;
}
var allRegistersHasPlausibilityReason = exports.allRegistersHasPlausibilityReason = function allRegistersHasPlausibilityReason(registers) {
  return registers.every(function (register) {
    return !(register.possibleReadingNotes && !register.readingNoteNumber);
  });
};